import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function ThankYouPage() {
  return <div className="min-h-screen bg-background text-textMain flex items-center justify-center p-6" data-id="element-7190">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="max-w-md w-full bg-surface border border-border rounded-2xl p-8 text-center" data-id="element-7191">
        <div className="w-16 h-16 rounded-full bg-green-500/20 text-green-500 flex items-center justify-center mx-auto mb-6" data-id="element-7192">
          <CheckCircle2 className="w-8 h-8" data-id="element-7193" />
        </div>
        <h1 className="text-3xl font-bold mb-4" data-id="element-7194">Message Received</h1>
        <p className="text-textMuted mb-8 leading-relaxed" data-id="element-7195">
          Thanks for reaching out! Our team has received your request and will
          be in touch shortly to discuss how Booker can help your workflow.
        </p>
        <div className="space-y-4" data-id="element-7196">
          <Link to="/" className="w-full py-3 bg-primary text-background rounded-xl font-medium hover:bg-primaryHover transition-colors flex items-center justify-center gap-2" data-id="element-7197">
            Return to Homepage <ArrowRight className="w-4 h-4" data-id="element-7198" />
          </Link>
          <Link to="/product" className="w-full py-3 bg-surface border border-border rounded-xl font-medium hover:bg-surfaceHover transition-colors block" data-id="element-7199">
            Explore the Product
          </Link>
        </div>
      </motion.div>
    </div>;
}